import axios from "axios";

const API_HOST = "https://api.gaurangavedic.org.in:8443";
// const API_HOST = "https://localhost:8443";
// console.log(API_HOST)

class DataServices {

    updateAbsentReason(payload) {
                            return axios({
                                method: "POST",
                                url: API_HOST + `/v1/attendance/japa/absentReason`,
                                data: payload,
                                withCredentials: true
                            })
                        }

    last7DaysAttendance(emails) {
                        return axios({
                            method: "POST",
                            url: API_HOST + `/v1/attendance/japa/last7DaysDetail?emails=${emails}`,
                            data: {},
                            withCredentials: true
                        })
                    }


     last7DaysChantingRounds(emails) {
                            return axios({
                                method: "POST",
                                url: API_HOST + `/v1/chanting/rounds/last7DaysDetail?emails=${emails}`,
                                data: {},
                                withCredentials: true
                            })
                        }

    saveParticipants(payload) {
                    return axios({
                        method: "POST",
                        url: API_HOST + `/v1/participants/japa/saveDevotee`,
                        data: payload,
                        withCredentials: true
                    })
                }

    getFacilitatorList() {
                return axios({
                    method: "POST",
                    url: API_HOST + `/v1/participants/japa/fetchFacilitators`,
                    data: {},
                    withCredentials: true
                })
            }

    top3participantsByDaysInPreviousMonth() {
                return axios({
                    method: "POST",
                    url: API_HOST + `/v1/analytics/japa/previous/top3PerGroup`,
                    data: {},
                    withCredentials: true
                })
            }

    top3participantsByDaysInCurrentMonth() {
            return axios({
                method: "POST",
                url: API_HOST + `/v1/analytics/japa/current/top3PerGroup`,
                data: {},
                withCredentials: true
            })
        }

    getParticipantsInfo(email) {
            return axios({
                method: "POST",
                url: API_HOST + `/v1/participants/japa/infoByEmail?loginEmail=${email}`,
                data: {},
                withCredentials: true
            })
        }

    getFacilitiesDataByEmail(email) {
        return axios({
            method: "POST",
            url: API_HOST + `/v1/participants/japa/facilitesId?loginEmail=${email}`,
            data: {},
            withCredentials: true
        })
    }

    getDevoteesDataforDOB() {
        return axios({
            method: "post",
            url: API_HOST + "/v1/participants/japa/fetchAllForDOB",
            withCredentials: true
        })
    }

    getJapaAttendanceDevoteeSingleData(email, month, year) {
        return axios({
            method: "post",
            url: API_HOST + `/v1/attendance/japa/monthlyDetail?email=${email}&month=${month}&year=${year}`,
            data: {},
            withCredentials: true
        })
    }

    getAlumniClassAttendanceDevoteeSingleData(email, month, year) {
        return axios({
            method: "post",
            url: API_HOST + `/v1/attendance/alumniClass/monthlyDetail?email=${email}&month=${month}&year=${year}`,
            data: {},
            withCredentials: true
        })
    }

    getFacilitiesData(email) {
        return axios({
            method: "post",
            url: API_HOST + `/v1/participants/japa/facilitesId?loginEmail=${email}`,
            data: {},
            withCredentials: true
        })
    }

    apiHealthCheck() {
            return axios({
                method: "get",
                url: API_HOST + `/v1/gvs/health`,
                data: {},
                withCredentials: true
            })
        }


}

export default new DataServices();
